import {FilterDialogSectionId} from 'filters/features/FilterDialog/types';
import {assertPolicyFilter, isPolicyFilter} from 'filters/types';
import {FilterTopbarItemId} from 'filters/features/FilterTopbar/types';

import {createTreeViewSection} from 'filters/features/FilterDialog/sections/TreeViewSection/TreeViewSection';
import {useDepartmentsTree} from 'modules/decisionsNext/hooks/trees/useDepartmentTree';
import {useDepartmentTreeViewSelection} from 'features/GlobalFilterProvider/filters/departments/useDepartmentTreeViewSelection';
import {createCounterItem} from 'filters/features/FilterTopbar/items/CounterItem/CounterItem';
import {openFilterDialog} from 'filters';
import {createDataCounterItem} from 'filters/features/FilterTopbar/items/CounterItem/DataCounterItem/DataCounterItem';

import GlobeIcon from 'components/icons/globe.svg';

import {useDepartmentLevelOptions} from 'modules/decisionsNext/components/BaseFilter/hooks/useDepartmentLevelOptions';

export const departmentsDialogSection = createTreeViewSection({
  id: FilterDialogSectionId.Departments,
  title: 'Business Org',
  icon: GlobeIcon,
  useTreeData: useDepartmentsTree,
  useTreeSelection: useDepartmentTreeViewSelection,
  getDataOptions: value => ({
    skip: !value.ids?.length,
  }),
  getValue: filter => {
    assertPolicyFilter(filter);

    return {
      ids: filter.departmentIds ?? null,
      level: filter.departmentLevel ?? undefined,
    };
  },
  onChange: (filter, value) => {
    assertPolicyFilter(filter);

    return {
      ...filter,
      departmentIds: value.ids?.length ? value.ids : undefined,
      departmentLevel: value.level,
    };
  },
});

const useDepartmentLevelData = ({skip}: {skip?: boolean}) => {
  const {options, loading} = useDepartmentLevelOptions(skip);

  return {
    data: options,
    loading,
  };
};

export const departmentsTopbarItems = [
  createDataCounterItem({
    id: FilterTopbarItemId.DepartmentLevel,
    entity: 'Biz Org Level',
    useData: useDepartmentLevelData,
    getDataOptions: filter => ({
      skip: !isPolicyFilter(filter) || !filter.departmentLevel,
    }),
    getCount: (filter, data) => {
      if (!isPolicyFilter(filter) || !filter.departmentLevel) {
        return;
      }

      return data?.find(option => option.id === filter.departmentLevel)?.shortLabel || filter.departmentLevel;
    },
    onClick: () => openFilterDialog(FilterDialogSectionId.Departments),
    onReset: filter => {
      assertPolicyFilter(filter);

      return {
        ...filter,
        departmentLevel: undefined,
      };
    },
  }),
  createCounterItem({
    id: FilterTopbarItemId.Departments,
    entity: 'Business Org',
    getCount: filter => {
      if (!isPolicyFilter(filter)) {
        return;
      }

      return filter.departmentIds?.length;
    },
    onClick: () => openFilterDialog(FilterDialogSectionId.Departments),
    onReset: filter => {
      assertPolicyFilter(filter);

      return {
        ...filter,
        departmentIds: undefined,
      };
    },
  }),
];
